import React from "react";

export default function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <img src="/wmremove-transformed.jpeg" alt="Doctor with patient" className="hero-logo" />
        <h1 className="hero-title">Compassionate Care for Your Whole Family</h1>
        <p className="hero-subtitle">
          Providing quality healthcare services with a personal touch in Illinois
        </p>
        <div className="hero-buttons">
          <a href="#contact" className="btn btn-primary">Schedule Appointment</a>
          <a href="#services" className="btn btn-secondary">Our Services</a>
        </div>
      </div>
      <div className="hero-overlay"></div>
    </section>
  );
}
